export const watchScrollDirection = function(scrollElement, callback) {
  const scrollPos = { x: 0, y: 0 };
  const scrollDirection = {
    directionX: 1,
    directionY: 1
  };
  let previousTimer;
  function onScroll(e) {
    const scrollTop = scrollElement.scrollTop || scrollElement.pageYOffset;
    const scrollLeft = scrollElement.scrollLeft || scrollElement.pageXOffset;

    if (scrollPos.y > scrollTop) {
      scrollDirection.directionY = -1;
    } else {
      scrollDirection.directionY = 1;
    }
    if (scrollPos.x > scrollLeft) {
      scrollDirection.directionX = -1;
    } else {
      scrollDirection.directionX = 1;
    }

    callback.call(scrollElement, scrollDirection, scrollPos);

    scrollPos.x = scrollLeft;
    scrollPos.y = scrollTop;
  }
  function throttle() {
    let now = Date.now();
    if (!previousTimer) previousTimer = now;
    if (now - previousTimer > 30) {
      onScroll();
      previousTimer = now;
    }
  }
  scrollElement.addEventListener("scroll", throttle);
  return function() {
    scrollElement.removeEventListener("scroll", throttle);
  };
};

export function formatDate(date, format = true) {
  date = new Date(date);
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  const Y = date.getFullYear();
  const M = (parseInt(date.getMonth()) + 1).toString().padStart(2, 0);
  const d = date
    .getDate()
    .toString()
    .padStart(2, 0);
  const h = date
    .getHours()
    .toString()
    .padStart(2, 0);
  const m = date
    .getMinutes()
    .toString()
    .padStart(2, 0);
  const s = date
    .getSeconds()
    .toString()
    .padStart(2, 0);

  return format ? `${Y}-${M}-${d} ${h}:${m}:${s}` : `${Y}-${M}-${d}`;
}

export function getOffsetTop(relativeNode, node, topSum = 0) {
  topSum += node.offsetTop;

  if (node.offsetParent !== relativeNode) {
    return getOffsetTop(relativeNode, node.offsetParent, topSum);
  }
  return topSum;
}

export function pick(obj = {}, keys = []) {
  const result = {};
  keys.forEach(key => {
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || "id",
    parentId: parentId || "parentId",
    childrenList: children || "children"
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
 * 防抖函数 在规定的时间内请求函数的次数
 * @param fn  需要执行的方法
 * @param t 执行的间隔时间
 */
export const Debounce = (fn, t) => {
  let delay = t || 500;
  let timer;
  return function() {
    let args = arguments;
    if (timer) {
      clearTimeout(timer);
    }

    let callNow = !timer;

    timer = setTimeout(() => {
      timer = null;
    }, delay);

    if (callNow) fn.apply(this, args);
  };
};

/**
 * 节流函数 在规定的时间内请求函数的次数
 * @param fn  需要执行的方法
 * @param interval 执行的间隔时间
 */
export function _throttle(fn, interval) {
  let last = 0;
  let timer;
  const interVal = interval || 200;
  return function() {
    const th = this;
    const args = arguments;
    const now = new Date().getTime();
    if (last && now - last < interVal) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        last = new Date().getTime();
        // fn.apply(th, args)
      }, interVal);
    } else {
      last = new Date().getTime();
      fn.apply(th, args);
    }
  };
}
